export class CFAccessDeniedError extends Error {
    private readonly body: string;

    constructor(message: string, body: string) {
        super(message);
        this.name = 'CFAccessDeniedError';
        this.body = body;
    }

    getBody = () => this.body;
}
